import { logout } from '@/app/auth/actions'
import { LogOut } from 'lucide-react'

export const LogoutButton = () => {

    return (<>
          <form action={logout} className="absolute bottom-5 flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors">
            <button className="w-full flex text-slate-600 hover:bg-slate-50 hover:text-slate-900" type="submit">
                <LogOut className="mr-3 h-4 w-4" />
                <span>Log out</span>
            </button>
          </form>
    </>)
}